/**
 * Splits a glued path back into its original parts
 * @param {string} gluedPath - The path string with encoded parts
 * @returns {string[]} - The original path parts
 */
export function splitParts(gluedPath: string) {
  // Split by colon and decode each part
  return gluedPath.split(':').map(part => decodeURIComponent(part))
}

export function topicMatches(topic: string | undefined | null, pattern: string) {
  if (!topic)
    return false
  const topicParts = splitParts(topic)
  const patternParts = splitParts(pattern)

  // Check if the number of parts matches
  if (topicParts.length !== patternParts.length) {
    return false
  }

  // Check each part for a match
  return topicParts.every((part, index) => {
    const patternPart = patternParts[index]
    return part === patternPart || patternPart === '*'
  })
}
